import React, { useEffect, useRef } from "react";

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// StrictMode-safe "still mounted" flag for async card sequences.
export const useAlive = () => {
  const alive = useRef(true);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  return alive;
};

export function RunButton({ tid, running, onClick, Icon, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={running}
      data-testid={tid}
      className="inline-flex items-center gap-1.5 rounded-lg bg-brand-cyan/90 hover:bg-brand-cyan text-navy-950 font-mono text-[11px] font-semibold tracking-[0.14em] uppercase px-3 py-1.5 transition-colors disabled:opacity-60"
    >
      <Icon className={`w-3.5 h-3.5 ${running ? "animate-spin" : ""}`} /> {label}
    </button>
  );
}
